import React, { Component, useState } from 'react'
import { withRouter } from '../../../utils/with-router'
import avatar from '../../Home/Speaker/speakers_avatars/avatar.svg'
import paul from '../../Home/Speaker/speakers_avatars/paul.svg'
import han from '../../Home/Speaker/speakers_avatars/han.svg'
import alan from '../../Home/Speaker/speakers_avatars/alan.svg'
import chair from '../../Home/Speaker/speakers_avatars/chair.png'
import cochair from '../../Home/Speaker/speakers_avatars/cochair.png'
import executive_director from '../../Home/Speaker/speakers_avatars/executive director.png'
import chief_of_staff_and_treasurer from '../../Home/Speaker/speakers_avatars/chief of staff.png'
import legal_counsel from '../../Home/Speaker/speakers_avatars/legal counsel.png'
import director from '../../Home/Speaker/speakers_avatars/director.png'
import './ExecutiveMembers.css'
import { getExecutiveMember, getBoardMembers } from '../../../fetcher'
import { Link } from 'react-router-dom';

class ExecutiveMembers extends Component {

    constructor(props) {
        super(props);
        this.state = {

            boardMembersLists: []

        };
    }

    componentDidMount() {
        this.fetchBoardMemberData();
    }

    fetchBoardMemberData = async () => {
        try {
            const memberData = await getExecutiveMember();
            let memberList = []
            console.log(memberData)
            memberData.records.forEach((speakerContentElement, index) => {
                const speaker = memberData.records[index].fields;
                let id = index;
                let name = speaker.Name;
                let company = speaker.Company ? speaker.Company.split(';') : [];
                let position = speaker.Position;
                let photo = speaker.Photo ? speaker.Photo[0].url : avatar;
                let order = speaker.Order;
                let title = speaker.Title || '';
                let memberDetail = { id: id, name: name, company: company, position: position, photo: photo, order: order, title: title };
                memberList.push(memberDetail);
            });

            this.setState({ boardMembersLists: memberList })

        } catch (error) {
            console.error(error);
        }
    };
    render() {
        const titleToBanner = {
            'Executive Director': executive_director,
            'Chief Staff and Treasurer': chief_of_staff_and_treasurer,
            'Legal Counsel': legal_counsel,
            'Director': director
        };

        let MemberList = this.state.boardMembersLists.map((item, index) => {
            const bannerImage = titleToBanner[item.title];
            const bannerClass = item.title === 'Executive Director' || item.title === 'Chief Staff and Treasurer'
                ? 'extra-div3'
                : 'extra-div4';

            return (
                <Link to={`/profile/executiveteam/${item.order}`} key={item.id} className='boardmembers_newList-one'>
                    <div className='boardmembers_speaker_content'>
                        <div className='boardmembers_speaker_avatar_container'>
                            <img className='boardmembers_speaker_avatar' src={avatar} alt="pic" />
                            <img className='boardmembers_speaker_pic' src={item.photo} alt="pic" />
                            {bannerImage && <img className={bannerClass} src={bannerImage} alt="pic" />}
                        </div>
                        <div className='boardmembers_speaker'>
                            <h1 className='boardmembers_speaker_name'>{item.name}</h1>
                            <h4 className='boardmembers_speaker_position'>{item.position}</h4>
                            {item.company.map((com, index) => (
                                <h4 key={index} className='boardmembers_speaker_company'>{com}</h4>
                            ))}
                        </div>
                    </div>
                </Link>
            );
        });

        return (
            <div className="BOARDMEMBERS">
                <h2 className='panel_title'>Executive Team</h2>
                <div className='boardmembers_speaker_container'>
                    {MemberList}
                </div>
            </div>
        );
    }
}

export default ExecutiveMembers;